import ServicePaymentsList from './_ServicePaymentsList';

export default ServicePaymentsList;
